import { useState } from "react"

import { Dropdown, Flex, Typography } from "antd"

import Avatar from "../../../../../../Components/Avatar"
import Icon from "../../../../../../Icon"

import styles from "./assigneeCell.module.less"

const { Text } = Typography

// Assignee cell: shows who a dispute is assigned to (plain name, no initials
// avatar) and opens a menu of the business's invited team members to (re)assign
// or unassign. The assign dispatch emails the new assignee (thunk + backend).
const AssigneeCell = ({ row, members, onAssign, t }) => {
  const current = row.assigned_to || null
  // Built ONLY while the menu is open. The card view renders every result at once, so
  // eagerly composing this list per row meant hundreds of menus (and their JSX labels)
  // constructed on every render of the list, which was enough to make the page crawl.
  const [open, setOpen] = useState(false)
  // Assignment is never locked by status: a settled dispute still needs an owner for
  // follow-up and reporting, so the menu stays available in every status (matches the
  // detail page's always-editable Assignee field).
  const memberItems = !open
    ? []
    : (members || []).map((m) => ({
        key: String(m.id),
        label: (
          <Flex align="center" gap={8} className={styles.opt}>
            <Avatar name={m.name} size={22} />
            <span className={styles.optName}>{m.name}</span>
            {current && String(current.id) === String(m.id) ? (
              <Icon type="check_mark" className={styles.optCheck} />
            ) : null}
          </Flex>
        ),
        onClick: () => onAssign({ id: m.id, name: m.name, email: m.email })
      }))
  // Reassign only: there is deliberately no Unassign action, because a dispute must
  // always have an owner. You can hand it to someone else, never to nobody.
  const items =
    !open || memberItems.length
      ? memberItems
      : [{ key: "__none__", label: t("No team members yet"), disabled: true }]
  return (
    <span onClick={(e) => e.stopPropagation()} className={styles.cell}>
      <Dropdown
        menu={{ items }}
        open={open}
        onOpenChange={setOpen}
        trigger={["click"]}
        placement="bottomLeft"
        getPopupContainer={() => document.getElementById("main-layout") || document.body}
      >
        {current ? (
          <span className={styles.trigger} role="button" tabIndex={0}>
            <Avatar name={current.name} size={22} />
            <Text ellipsis className={styles.name}>
              {current.name}
            </Text>
            <Icon type="chevron_down_small" className={styles.caret} />
          </span>
        ) : (
          <span className={`${styles.trigger} ${styles.triggerEmpty}`} role="button" tabIndex={0}>
            <Icon type="plus" />
            <Text type="secondary">{t("Assign")}</Text>
          </span>
        )}
      </Dropdown>
    </span>
  )
}

export default AssigneeCell
